import { format } from 'date-fns';

import { Box, FilterChip } from '@zillow/constellation-10';

import { dayChipRowStyles } from './styles';
import { ToursSummaryDayChipType } from './types';
import type { UpcomingToursDay } from '../../hooks/useUpcomingToursData';

type DayChipsProps = {
  days: Array<UpcomingToursDay>;
  selectedIndex: number;
  onSelect: (dayIndex: number, chip: ToursSummaryDayChipType) => void;
};

// Labeled by position: the data hook anchors days[0] to the listing's "today" on every render, and
// the viewer's clock can legitimately sit on a different calendar day than the listing's, so
// date-fns' viewer-clock isToday/isTomorrow would mislabel out-of-zone listings.
const DAY_CHIPS = [
  { label: 'Today', type: ToursSummaryDayChipType.Today },
  { label: 'Tomorrow', type: ToursSummaryDayChipType.Tomorrow },
];

const getDayChipLabel = (date: Date, dayIndex: number) => DAY_CHIPS[dayIndex]?.label ?? format(date, 'EEEE');

const getDayChipType = (dayIndex: number): ToursSummaryDayChipType =>
  DAY_CHIPS[dayIndex]?.type ?? ToursSummaryDayChipType.DayAfterTomorrow;

const DayChips = ({ days, selectedIndex, onSelect }: DayChipsProps) => (
  <Box css={dayChipRowStyles}>
    {days.map((day, dayIndex) => {
      const chipType = getDayChipType(dayIndex);

      return (
        <FilterChip
          key={day.date.toDateString()}
          selected={dayIndex === selectedIndex}
          onSelectedChange={(selected) => selected && onSelect(dayIndex, chipType)}
          data-testid={`ToursSummary-dayChip-${dayIndex}`}
        >
          {getDayChipLabel(day.date, dayIndex)}
        </FilterChip>
      );
    })}
  </Box>
);

export default DayChips;
